import React from 'react';
import AutoGainCheckbox from 'app/components/DeviceSetup/AutoGainCheckbox';
import FlexMarginGroup from 'app/components/layout/FlexMarginGroup';
import MarginGroup from 'app/components/layout/MarginGroup';
import { useI18n } from 'app/components/localization';
import { ButtonA, ColorScheme } from 'app/components/presentation/buttons/ButtonClassNameA';
import {
  DeviceType,
  useDeviceManager,
  useDeviceManagerState,
  useIsDeviceManagerBusy,
} from 'app/containers/rtc/DeviceManagerContext';
import DeviceWarning from './DeviceWarning';
import SwitchDevice from './SwitchDevice';

const DeviceSettings = ({ type }: { type: DeviceType }) =>
  <MarginGroup>
    <DeviceWarning type={type} />
    <GrantAccessOrDeviceSettings type={type} />
  </MarginGroup>;

const GrantAccessOrDeviceSettings = ({ type }: { type: DeviceType }) => {
  const devices = useDeviceManagerState();

  if (!devices) return null;

  if (devices[type].isSkipped) return <GrantAccess type={type} />;

  switch (type) {
    case DeviceType.Audio: return <AudioInputSettings />;
    case DeviceType.Video: return <VideoInputSettings />;
  }
};

const VideoInputSettings = () => <SwitchDevice type={DeviceType.Video} />;

const AudioInputSettings = () =>
  <FlexMarginGroup margin="10px" vertical>
    <SwitchDevice type={DeviceType.Audio} />
    <AutoGainCheckbox />
  </FlexMarginGroup>;

const GrantAccess = ({ type }: { type: DeviceType }) => {
  const manager = useDeviceManager();
  const isBusy = useIsDeviceManagerBusy();
  const { t } = useI18n();

  if (!manager) return null;

  return <ButtonA
    colorScheme={ColorScheme.Secondary}
    disabled={isBusy}
    onClick={() => {
      const setEnabled = type === DeviceType.Audio
        ? manager.setAudioEnabled
        : manager.setVideoEnabled;
      setEnabled(true);
    }}
  >
    {t('rtc.device-setup.initial.enable')}
  </ButtonA>;
};

export default DeviceSettings;
